import { useLazyQuery, useMutation } from '@apollo/client';
import LibraryHeader from '../../components/LibraryHeader/LibraryHeader';
import FileUpload, { categoryType } from '../../components/Popups/FileUpload';
import './SyndicatedVideos.scss';
import { useCallback, useEffect, useRef, useState } from 'react';
import ToasterWithMessage from '../../components/toaster';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import UploadToaster from '../../components/Popups/UploadProgressBar/UploadProgressPopup';
import { useAppSelector } from '../../redux/app/hooks';
import { 
    FETCH_POLICY, 
    FETCH_POLICY_NO_CACHE, 
    MYLIBRARY_TEXTS, 
    PATH_ADDRESSES, 
    SCHOOL_ADMIN, 
    STUDENT_ROLE, 
    SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR, 
    SUBJECT_NOT_FOUND_ERROR, 
    TEACHER_ROLE 
} from '../../utils/constants';
import { debounce } from 'lodash';
import { 
    EDIT_SYNDICATED_VIDEOS, 
    GET_ALL_SYNDICATED_VIDEOS, 
    GET_ALL_SYNDICATED_VIDEOS_ADMIN, 
    INSERT_SYNDICATED_VIDEOS, 
    UPDATE_PLAY_BACK_TIME_FOR_SYNDICATED_VIDEO, 
    UPLOAD_SYNDICATED_VIDEOS_ADMIN 
} from './api/SyndicatedVideosQuery';
import SyndicatedVideosCards from '../../components/SyndicatedVideosCards/SyndicatedVideosCards';
import VideoViewer from '../../components/VideoViewer/VideoViewer';
import { DELETE_IMAGES_PODCASTS, DELETE_IMAGES_PODCASTS_ADMIN, UPDATE_IMAGES_PODCASTS, UPDATE_IMAGES_PODCASTS_ADMIN } from '../ImageMaterial/api/ImageMaterialQuery';
import { useDispatch } from 'react-redux';
import { setCurrentVideoData } from '../../redux/slices/dashboardSlice';
import { READ_CLASSROOMUPDATES } from '../TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import { getScreenDimensions } from '../../utils/helper';
import images from '../../assets/images';
import { SharedBy } from '../../utils/interface';
import CommonBulkUpload, { BulkFileState } from '../../components/Popups/CommonBulkUpload/CommonBulkUpload';
import UploadResultModal, { UploadResult, UploadResultForTeacher } from '../AdminBulkUpload/components/UploadResultModal';
export interface VideosData {
    categoryName:string;
    categoryOriginalName: string;
    categoryId:string;
    datas: VideosListForCategory[];
    totalCount: number;
}
export interface VideosListForCategory{
      categoryId: string;
      categoryName: string;
      coverImagePath: string;
      fileId: string;
      filename: string;
      filepath: string;
      filesize:  number;
      isClassroom: boolean;
      playbackTime: string | null;
      feedId? : string;
      sharedBy ? : SharedBy
}

export interface UploadedFilePayload {
  filename: string;
  filepath: string;
  filesize: number;
  filetype?: string | null;
  fileDescription?: string;
  category_id?: string;
  authorName?: string;
}

const SyndicatedVideos = () => {
    const dispatch = useDispatch();
    const [url, setUrl] = useState<string>();
    const [filename, setFilename] = useState<string>();
    const [videoFileData, setVideoFileData] = useState<VideosListForCategory | undefined>();
    const [fileData, setFileData] = useState<File | null>();
    const [guideCoverUrl,setGuideCoverUrl] = useState<string>();
    const [videoCategoryData, setVideoCategoryData] = useState<categoryType|null|undefined>();
    const [isUploadOpen, setIsUploadOpen] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const [openVideo, setOpenVideo] = useState(false);
    const [videosData, setVideosData] = useState<VideosData[]>();
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadFailed, setUploadFailed] = useState<boolean>(false);
    const [uploadFileName, setUploadFileName] = useState<string>('');
    const [materialAction,setMaterialAction] = useState<string>('');
    const [searchValue, setSearchValue] = useState<string>('');
    const [uploaded, setuploaded] = useState(false);
    const { success, error } = ToasterWithMessage();
    const { state:locationState } = useLocation();
    const selectedLibraryId = localStorage.getItem('selectedLId');
    const selectedSubjectId = localStorage.getItem('selectedSId');
    const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
    const role = useAppSelector((state) => state.auth.role);
    const [refetch, SetRefetch] = useState<boolean>(false);
    const videoRef = useRef<HTMLVideoElement | null>(null);
    const clickedVideoRefValue = useAppSelector((state) => state.dashboard.clickedVideoData);
    const backNavigation = role === SCHOOL_ADMIN  ?  "/admin-materials-upload/materials/videos" : role ===STUDENT_ROLE ? '/student-classroom/videos' : '/teacher-classroom/videos';
    const profile = useAppSelector((state) => state?.auth?.adminProfile);
    const currentVideoData = useAppSelector((state) => state?.dashboard?.clickedVideoData);
    const {uploadCloud} = images;
     const selectedClassroomIdAdmin = useAppSelector(
        (state) => state.CommonUpload.classroomId
      );
    const [isEditVideo, setIsEditVideo] = useState<boolean>(false);
    const [hasSubmittedForEdit, setHasSubmittedForEdit] = useState<boolean>(false);

    const [FilesStatusData, setFilesStatusData] = useState<Array<BulkFileState>>([]);
    const [uploadedPayloads, setUploadedPayloads] = useState<UploadedFilePayload[]>([]);
    const [totalProgress, setTotalProgress] = useState<number>(0);
    const [successCount, setSuccessCount] = useState<number>(0);
    const [failureCount, setFailureCount] = useState<number>(0);
    const [uploadResults, setUploadResults] = useState<UploadResult[]>([]);
    const [upoloadResultsForTeacher, setUploadResultsForTeacher] = useState<UploadResultForTeacher>();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const navigate = useNavigate();

    const [updatePlayBackTimeForSyndicatedVideo, {loading: uploadLoading}] = useMutation(UPDATE_PLAY_BACK_TIME_FOR_SYNDICATED_VIDEO, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {
            dispatch(setCurrentVideoData({
                videoCurrentTime: 0,
                videoId: ''
            }));
        },
        onError: (err) => {}
    });
  
    const [getAllSyndicatedVideos, { loading }] = useLazyQuery(GET_ALL_SYNDICATED_VIDEOS, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.getSyndicatedVideos) {
                setVideosData(data?.getSyndicatedVideos);
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate('/student-classroom/videos', { state: { title: MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT } });
                    } else {
                        navigate('/teacher-classroom/videos', { state: { title: MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT } });
                    }
                }, 2000);
            }
        }
    });

    const [getAllSyndicatedVideosAdmin, { loading : AdminLoading }] = useLazyQuery(GET_ALL_SYNDICATED_VIDEOS_ADMIN, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.getSyndicatedVideosByCategoryForAdmin) {
                setVideosData(data?.getSyndicatedVideosByCategoryForAdmin);
            }
        },
        onError: (err) => {
            error(err?.message);
            console.error(err?.message)
        }
    });


    const [readFeed] = useMutation(READ_CLASSROOMUPDATES, {
        fetchPolicy: FETCH_POLICY,
        onCompleted : (data) =>{
        },
        onError: (err) =>{
          console.log(err.message)
        }
      })

    
      useEffect(()=>{
    if(role === STUDENT_ROLE){
      if(videosData){
        videosData?.forEach((data) => {
            const validFeedId = data.datas.find(item => item.feedId)?.feedId;
            if (validFeedId) {
                readFeed({
                  variables: {
                    fId: validFeedId,
                    uId: profile?.getCurrentUser?.nodes?.[0]?.uId
                  }
                });
              }
        });
      }
    }
      },[profile?.getCurrentUser?.nodes, readFeed, role, videosData])

    const [uploadSyndicatedvideo] = useMutation(INSERT_SYNDICATED_VIDEOS, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.uploadMultipleMylibrarySyndicatedVideos?.json) {
                setUploadedPayloads([]);

                const result = data?.uploadMultipleMylibrarySyndicatedVideos?.json || {};
                setUploadResultsForTeacher(result);

                const hasFailures =
                result.failed_count > 0 ||
                result.results.some((item: any) => item.status === "error");

                if (hasFailures) {
                    setIsModalOpen(true);
                } else {
                    success("Uploaded successfully!");
                }

                setFileData(null);
                if (filename) {
                    setUploadFileName(filename);
                }
                setuploaded(true);
                setUploadProgress(100);
                setFilename('');
                setUrl('');
                setGuideCoverUrl('');
                setVideoCategoryData(null);
                getAllSyndicatedVideos({
                    variables: {
                        input:{
                            cId: selectedClassRoomId,
                            lId: selectedLibraryId,
                            sjId: selectedSubjectId,
                            searchInput: `%${searchValue.trim()}%`,
                            category: [
                            {
                                categoryId: "",
                                limit: null,
                                offset: null
                            }
                            ]
                    }
                }
                })
            }
        },
        onError: (err) => {
            setUploadedPayloads([]);
            if (filename) {
                setUploadFileName(filename);
            }
            setuploaded(true);
            setUploadProgress(0);
            setUploadFailed(true);
        }
    });

const [uploadSyndicatedvideoAdmin] = useMutation(UPLOAD_SYNDICATED_VIDEOS_ADMIN, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.uploadMylibrarySyndicatedVideosBySchoolAdmin) {
                setUploadedPayloads([]);

                const result = data.uploadMylibrarySyndicatedVideosBySchoolAdmin?.result || [];

                setUploadResults(result);

                const hasFailures = result.some(
                    (res: UploadResult) => res.classrooms_failed.length > 0
                );

                if (hasFailures) {
                    setIsModalOpen(true);
                } else {
                    success("Uploaded successfully!");
                }

                setFileData(null);
                if (filename) {
                    setUploadFileName(filename);
                }
                setuploaded(true);
                setUploadProgress(100);
                setFilename('');
                setUrl('');
                setGuideCoverUrl('');
                setVideoCategoryData(null);
                getAllSyndicatedVideosAdmin({
                  variables: {
                    subjectId: selectedSubjectId,
                    searchInput: `%${searchValue.trim()}%`,
                    classroomIds : [selectedClassroomIdAdmin]
                  },
                });
            }
        },
        onError: (err) => {
            setUploadedPayloads([]);
            if (filename) {
                setUploadFileName(filename);
            }
            setuploaded(true);
            setUploadProgress(0);
            setUploadFailed(true);
        }
    });

    const [editSyndicatedVideo] = useMutation(EDIT_SYNDICATED_VIDEOS, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
           if(data?.editMylibrarySyndicatedVideo) {
                setFileData(null);
                if(!(fileData && url)) {
                    success("File updated successfully!");
                }
                if(fileData && url) {
                    if (filename) {
                        setUploadFileName(filename);
                    }
                    setuploaded(true);
                    setUploadProgress(100);
                }
                setFilename('');
                setUrl('');
                setGuideCoverUrl('');
                setVideoCategoryData(null);
                setHasSubmittedForEdit(false);
                setMaterialAction('');
                if(role === SCHOOL_ADMIN){
                    getAllSyndicatedVideosAdmin({
                        variables: {
                            subjectId: selectedSubjectId,
                            searchInput: `%${searchValue.trim()}%`,
                            classroomIds : [selectedClassroomIdAdmin]
                        },
                    });
                } else {
                    getAllSyndicatedVideos({
                    variables: {
                        input:{
                            cId: selectedClassRoomId,
                            lId: selectedLibraryId,
                            sjId: selectedSubjectId,
                            searchInput: `%${searchValue.trim()}%`,
                            category: [
                            {
                                categoryId: "",
                                limit: null,
                                offset: null
                            }
                            ]
                    }
                }
                })
                }
           }
        },
        onError: (err) => {
            error(err?.message);
            if (filename) {
                setUploadFileName(filename);
            }
            if(fileData && url) {
                setuploaded(true);
                setUploadProgress(0);
                setUploadFailed(true);
            }
        }
    });

    const [updateSyndicatedVideos] = useMutation(UPDATE_IMAGES_PODCASTS, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.updateImagesPodcastMaterials) {
                if(materialAction === "share"){
                    success("Shared successfully");
                }else if(materialAction === "undoShare"){
                    success("Unshared successfully");
                }
                SetRefetch(!refetch);
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    } else {
                        navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });


     const [updateSyndicatedVideosAdmin] = useMutation(UPDATE_IMAGES_PODCASTS_ADMIN, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.updateImagesPodcastMaterialsBySchoolAdmin) {
                if(materialAction === "share"){
                    success("Shared successfully");
                }else if(materialAction === "undoShare"){
                    success("Unshared successfully");
                }
                SetRefetch(!refetch);
            }
        },
        onError: (err) => {
            error(err?.message);
            console.error(err?.message)
        }
    });

    const [deleteSyndicatedVideos] = useMutation(DELETE_IMAGES_PODCASTS, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.deleteImagesAndPodcasts) {
                success("Deleted successfully");
                SetRefetch(!refetch);
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    } else {
                        navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });


    const [deleteSyndicatedVideosAdmin] = useMutation(DELETE_IMAGES_PODCASTS_ADMIN, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.deleteImagesPodcastsBySchoolAdmin) {
                success("Deleted successfully");
                SetRefetch(!refetch);
            }
        },
        onError: (err) => {
            error(err?.message);
            console.error(err?.message)
        }
    });


    useEffect(() => {
         if(role === SCHOOL_ADMIN){
            getAllSyndicatedVideosAdmin({
              variables : {
                 subjectId : selectedSubjectId,
                searchInput: `%${searchValue.trim()}%`,
                classroomIds : [selectedClassroomIdAdmin]
                }
             })
            }
        else{
        getAllSyndicatedVideos({
            variables: {
                input:{
                    cId: selectedClassRoomId,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    searchInput: '%%',
                    category: [
                    {
                        categoryId: "",
                        limit: null,
                        offset: null
                    }
                    ]
            }
        }
        });
        }
    }, []);

    useEffect(() => {
        if(role === SCHOOL_ADMIN){
            getAllSyndicatedVideosAdmin({
              variables : {
                 subjectId : selectedSubjectId,
                 searchInput: `%${searchValue.trim()}%`,
                 classroomIds : [selectedClassroomIdAdmin]
                }
             })
            }
        else{
        getAllSyndicatedVideos({
            variables: {
              input:{
                cId: selectedClassRoomId,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    searchInput: `%${searchValue.trim()}%`,
                    category: [
                        {
                            categoryId: "",
                            limit: null,
                            offset: null
                        }
                    ]
                }
            }
        })
    }
    }, [refetch]);

    useEffect(() => {
        if(materialAction === 'edit' && (hasSubmittedForEdit === true)){
            let newFileName;
            let newFilePath;
            let newFileSize;
            let newCategoryId;
            let newCoverImagePath;

            if(filename !== videoFileData?.filename){
                newFileName = filename?.replace(/\.pdf$/, "")?.trim();
            }
            if(url && fileData) {
                newFilePath = url;
                newFileSize = fileData?.size;
            }
            if(videoCategoryData?.id && videoCategoryData?.id !== videoFileData?.categoryId) {
                newCategoryId = videoCategoryData?.id?.trim();
            }
            if(guideCoverUrl && guideCoverUrl !== videoFileData?.coverImagePath) {
                newCoverImagePath = guideCoverUrl;
            }

            console.log("new values after assignment", newFileName, newFilePath, newFileSize, newCategoryId, newCoverImagePath);

            editSyndicatedVideo({
                variables: {
                    fileId: videoFileData?.fileId,
                    classroomId: (role === SCHOOL_ADMIN) ? [selectedClassroomIdAdmin] : selectedClassRoomId,
                    subjectId: selectedSubjectId,
                    ...(newCategoryId && { newCategoryId: newCategoryId }),
                    ...(newCoverImagePath && { newCoverImage: newCoverImagePath }),
                    ...(newFileName && { newFilename: newFileName }),
                    ...(newFilePath && newFileSize && { newFilepath: newFilePath }),
                    ...(newFilePath && newFileSize && { newFilesize: newFileSize })
                }
            })
        }
    }, [fileData, filename, url, videoCategoryData, guideCoverUrl, hasSubmittedForEdit]);

    const formatUploadedPayloads = (
    uploadedPayloads: UploadedFilePayload[],
    guideCoverUrl: string | undefined,
    videoCategoryDataId: string,
    ) => {
    const isSingle = uploadedPayloads.length === 1;
    const isTeacher = role === "teacher";

  return uploadedPayloads.map((item) => {
    const categoryValue = isSingle
      ? videoCategoryDataId?.trim()
      : item?.category_id?.trim();

    return {
        filename: item.filename?.replace(/\.pdf$/, "")?.trim(),
        filepath: item.filepath,
        filesize: item.filesize,
        isClassroom: false,
        coverImagePath: guideCoverUrl || null,
        ...(isTeacher
            ? { categoryId: categoryValue }
            : { category_id: categoryValue }
        ),
    };
    });
    };

    useEffect(() => {
        if(uploadedPayloads.length > 0 ){
            const updatedFormattedPayload = formatUploadedPayloads(
                uploadedPayloads,
                guideCoverUrl,
                videoCategoryData?.id || ''
            );

            if(role === SCHOOL_ADMIN){
            uploadSyndicatedvideoAdmin({
               variables: {
                 subjectId: selectedSubjectId,
                 classroomIds: [selectedClassroomIdAdmin],
                 files: updatedFormattedPayload
               },
             });
            } else if(role === TEACHER_ROLE) {
            uploadSyndicatedvideo({
                variables: {
                    libraryId: selectedLibraryId,
                    classroomId: selectedClassRoomId,
                    subjectId: selectedSubjectId,
                    files: updatedFormattedPayload
                }
            })
            }
        }
    }, [ uploadedPayloads ]);

    const handleSearchDebounce = useCallback(
        debounce((value) => {
            setSearchValue(value);
            if(role === SCHOOL_ADMIN){
            getAllSyndicatedVideosAdmin({
              variables : {
                 subjectId : selectedSubjectId,
                 searchInput: `%${value.trim()}%`,
                 classroomIds : [selectedClassroomIdAdmin]
                }
             })
            }else{
            getAllSyndicatedVideos({
                variables: {
                    input:{
                        cId: selectedClassRoomId,
                        lId: selectedLibraryId,
                        sjId: selectedSubjectId,
                        searchInput: `%${value.trim()}%`,
                        category: [
                        {
                            categoryId: "",
                            limit: null,
                            offset: null
                        }
                        ]
                }
            }
            });
        }
        }, 500),
        [getAllSyndicatedVideos]
    );

    //To open pdf in detailed view
    const handleOpenFile = (data: VideosListForCategory) => {
        setOpenVideo(true);
        setVideoFileData(data);
    }

    //To close pdf detailed view
    const handleCloseVideo = (prevVideoRef: any = null) => {
        if(openVideo && prevVideoRef){
            dispatch(setCurrentVideoData({
                videoCurrentTime: prevVideoRef.currentTime,
                videoId: videoFileData?.fileId ?? ''
            }))
        }
        setOpenVideo(false);
        setVideoFileData(undefined);
    }

    //To done actions in materials
    const handleVideoActions = (data: VideosListForCategory, action: string) => {
        if (action === "share") {
            setMaterialAction("share");
             if(role === SCHOOL_ADMIN){
              updateSyndicatedVideosAdmin({
                variables: {
                  input: {
                    pSubjectId: selectedSubjectId,
                    pFileId: data?.fileId,
                    pIsClassroom: true,
                    pLType: MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT,
                    pClassroomIds: [selectedClassroomIdAdmin],
                  },
                },
              });
            }else{
            updateSyndicatedVideos({
                variables:{
                    isClassroom: true,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    cId: selectedClassRoomId,
                    fId: data?.fileId
                }
            });
        }
        } else if (action === "undoShare") {
            setMaterialAction("undoShare");
             if(role === SCHOOL_ADMIN){
              updateSyndicatedVideosAdmin({
                variables: {
                  input: {
                    pSubjectId: selectedSubjectId,
                    pFileId: data?.fileId,
                    pIsClassroom: false,
                    pLType: MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT,
                    pClassroomIds: [selectedClassroomIdAdmin],
                  },
                },
              });
            }else{
            updateSyndicatedVideos({
                variables: {
                    isClassroom: false,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    cId: selectedClassRoomId,
                    fId: data?.fileId
                }
            });
           }
        } else if (action === "delete") {
            setMaterialAction('');
            if(role === SCHOOL_ADMIN){
              deleteSyndicatedVideosAdmin({
                variables: {
                  input: {
                    pSubjectId: selectedSubjectId,
                    pFileId: data?.fileId,
                    pLType: MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT,
                    pClassroomIds: [selectedClassroomIdAdmin],
                  },
                },
              });
            }else{
            deleteSyndicatedVideos({
                variables: {
                        cId: selectedClassRoomId,
                        fId: data?.fileId,
                        lId: selectedLibraryId,
                        sjId: selectedSubjectId,
                }
            })
        }
        } else if (action === "edit") {
            setMaterialAction('edit');        
            setIsEditVideo(true);    
            setIsUploadOpen(true);
            setOpen(true);
            setVideoFileData(data);
        }
    };

    useEffect(() => {
        if(clickedVideoRefValue && clickedVideoRefValue?.videoId){
             // Store the current time when the video is paused
            SetRefetch(!refetch);
            updatePlayBackTimeForSyndicatedVideo({
                variables: {
                    input: {
                      videosPlaybacktime: {
                        fId: clickedVideoRefValue?.videoId,
                        uId: profile.getCurrentUser.nodes[0].uId,
                        playbackTime: clickedVideoRefValue?.videoCurrentTime.toString()
                      }
                    }
                }
            });
        }
    },[clickedVideoRefValue])

    const handleOpenUpload = () => {
        setIsUploadOpen(true);
        setOpen(true);
    };

    return (
        <div className={`SyndicatedVideos ${role === SCHOOL_ADMIN ? "schoolAdminMaterials":""}`}>
            <LibraryHeader
                image={locationState?.imageSrc}
                backgroundColor={locationState?.backGroundColor}
                subject={locationState?.title}
                subCategory={`Syndicated Videos ${openVideo ? ('/ ' + videoFileData?.categoryName) : ''}`}
                setIsUploadOpen={setIsUploadOpen}
                openPdf={openVideo}
                onClose={handleCloseVideo}
                setOpen={setOpen}
                backNavigation={{ path: backNavigation, state: { title: MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT } }}
                handleSearchDebounce={handleSearchDebounce}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                openVideo = {openVideo}
                videoRef={videoRef}
            />
            {
                openVideo ?
                    <VideoViewer 
                        video={videoFileData?.filepath ? baseUrl + videoFileData.filepath : ''} 
                        onClose={handleCloseVideo} 
                        type={MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT} 
                        videoRef = {videoRef}
                        videoId = {videoFileData?.fileId ? videoFileData?.fileId : ''}
                        videoData = {videoFileData}
                    />
                    :
                    <>
                        {
                            (loading || uploadLoading || AdminLoading) ? <Loader bottom='165px' />
                                :
                                (currentVideoData?.videoId === "") && <div className='SyndicatedVideosBody' style={{height: role=== STUDENT_ROLE? '100%' : ''}}>
                                    <SyndicatedVideosCards
                                        subject={locationState?.title}
                                        subCategory={MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT}
                                        videosData={videosData}
                                        handleOpenFile={handleOpenFile}
                                        handleVideoActions={handleVideoActions}
                                        reload={()=>SetRefetch(!refetch)}
                                    />
                                </div>
                        }
                    </>
            }
            {isUploadOpen && !isEditVideo && 
                <CommonBulkUpload 
                    page={MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT} 
                    type='video' 
                    name={MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT} 
                    setUploadedPayloads = {setUploadedPayloads} 
                    setFilesStatusData = {setFilesStatusData} 
                    setTotalProgress = {setTotalProgress} 
                    setSuccessCount = {setSuccessCount} 
                    setFailureCount = {setFailureCount} 
                    setVideoCategoryData = {setVideoCategoryData} 
                    setCoverImageUrl ={setGuideCoverUrl} 
                    setUrl={setUrl} 
                    open={open} 
                    setOpen={setOpen} 
                    setIsUploadOpen={setIsUploadOpen} 
                    folderName="materials" 
                    setFilename={setFilename} 
                    setFileData={setFileData} 
                    setUploadFailed={setUploadFailed} 
                    setUploadProgress={setUploadProgress} 
                    setuploaded={setuploaded} 
                    setUploadFileName={setUploadFileName}
                />
            }
            {isUploadOpen && videoFileData && isEditVideo && 
                <FileUpload 
                    page={MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT} 
                    type='video' 
                    setHasSubmittedForEdit={setHasSubmittedForEdit} 
                    setMaterialAction={setMaterialAction} 
                    setVideoFileData={setVideoFileData} 
                    selectedFileData = {videoFileData} 
                    isEdit = {isEditVideo} 
                    setIsEdit = {setIsEditVideo} 
                    name={MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT} 
                    setVideoCategoryData = {setVideoCategoryData} 
                    coverImageUrl = {guideCoverUrl} 
                    setCoverImageUrl ={setGuideCoverUrl} 
                    setUrl={setUrl} 
                    open={open} 
                    setOpen={setOpen} 
                    setIsUploadOpen={setIsUploadOpen} 
                    folderName="materials" 
                    setFilename={setFilename} 
                    setFileData={setFileData} 
                    setUploadFailed={setUploadFailed} 
                    setUploadProgress={setUploadProgress} 
                    setuploaded={setuploaded} 
                    setUploadFileName={setUploadFileName}
                />
            }
            {uploaded && 
            <UploadToaster 
                successCount = {successCount} 
                failureCount={failureCount} 
                uploaded={uploaded} 
                FilesStatusData = {FilesStatusData} 
                setFilesStatusData = {setFilesStatusData} 
                totalProgress = {totalProgress} 
                setTotalProgress = {setTotalProgress} 
                setuploaded={setuploaded} 
                uploadProgress={uploadProgress} 
                setUploadProgress={setUploadProgress} 
                fileName={uploadFileName} 
                setUploadFileName={setUploadFileName} 
                uploadFailed={uploadFailed} 
                setUploadFailed={setUploadFailed} 
            />}
            <UploadResultModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                results={uploadResults}
                uploadResultsForTeacher = {upoloadResultsForTeacher}
                page='SyndicatedVideosDirectClass'
            />
             {(getScreenDimensions()?.isMobileScreen && role !== STUDENT_ROLE) && !openVideo &&
                        <div className='libraryHeaderUploadContainer'> 
                        <div className='libraryHeaderUpload' onClick={handleOpenUpload}>
                         <img src={uploadCloud} alt="upload" className='uploadImage' />
                        </div>
                        </div>}
        </div>
    )
}

export default SyndicatedVideos;
